// Mega Menu Navigation Enhancement
// Allows parent items to be clickable while maintaining dropdown functionality

document.addEventListener('DOMContentLoaded', function() {
  // Get all parent menu items with dropdowns
  const parentMenuItems = document.querySelectorAll('.list-menu__item > .header__menu-item');
  
  parentMenuItems.forEach(menuItem => {
    const parentLi = menuItem.closest('.list-menu__item');
    const dropdown = parentLi.querySelector('.mega-menu, .header__submenu');
    
    if (dropdown) {
      // Prevent default link behavior on click if dropdown is not visible
      menuItem.addEventListener('click', function(e) {
        // On mobile or if dropdown is hidden, allow navigation
        if (window.innerWidth < 1200) {
          return; // Allow normal navigation on mobile
        }
        
        // Check if dropdown is currently visible
        const dropdownStyles = window.getComputedStyle(dropdown);
        const isVisible = dropdownStyles.opacity === '1' && dropdownStyles.visibility === 'visible';
        
        if (!isVisible) {
          // First click opens dropdown
          e.preventDefault();
          // Force show dropdown
          dropdown.style.opacity = '1';
          dropdown.style.visibility = 'visible';
          
          // Hide other dropdowns
          document.querySelectorAll('.mega-menu, .header__submenu').forEach(otherDropdown => {
            if (otherDropdown !== dropdown) {
              otherDropdown.style.opacity = '';
              otherDropdown.style.visibility = '';
            }
          });
        }
        // Second click (when dropdown is visible) navigates to the link
      });
      
      // Hide dropdown when clicking outside
      document.addEventListener('click', function(e) {
        if (!parentLi.contains(e.target)) {
          dropdown.style.opacity = '';
          dropdown.style.visibility = '';
        }
      });
    }
  });
  
  // Add active state to current page menu items
  const currentPath = window.location.pathname;
  
  document.querySelectorAll('.header__menu-item').forEach(menuItem => {
    const link = menuItem.getAttribute('href') || menuItem.querySelector('a')?.getAttribute('href');
    
    if (link) {
      // Check if this is the current page or a parent of the current page
      if (currentPath === link || currentPath.startsWith(link + '/')) {
        menuItem.classList.add('header__menu-item--active');
      }
      
      // Special handling for collections
      if (link.includes('/collections/mens') && currentPath.includes('/collections/mens')) {
        menuItem.classList.add('header__menu-item--active');
      }
      if (link.includes('/collections/womens') && currentPath.includes('/collections/womens')) {
        menuItem.classList.add('header__menu-item--active');
      }
    }
  });
});